if (!customElements.get('product-usp-tiles')) {
  class ProductUspTiles extends HTMLElement {
    constructor() {
      super();
      this.grid = this.querySelector('[data-product-usp-tiles-grid]');
      this.variantData = this.getVariantData();
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    connectedCallback() {
      this.variantPicker = this.closest('.product')?.querySelector('variant-picker');
      this.variantPicker?.addEventListener('on:variant:change', this.handleVariantChange);
    }

    disconnectedCallback() {
      this.variantPicker?.removeEventListener('on:variant:change', this.handleVariantChange);
    }

    getVariantData() {
      const dataEl = this.querySelector('script[type="application/json"]');

      if (!dataEl) return {};

      try {
        return JSON.parse(dataEl.textContent);
      } catch (error) {
        return {};
      }
    }

    handleVariantChange(evt) {
      if (!evt.detail.variant) {
        this.renderTiles([]);
        return;
      }

      this.renderTiles(this.variantData[evt.detail.variant.id] || []);
    }

    renderTiles(tiles) {
      if (!this.grid) return;

      this.hidden = tiles.length === 0;
      this.grid.replaceChildren(
        ...tiles.map((tile) => {
          const tileEl = document.createElement('span');
          const iconEl = document.createElement('span');
          const labelEl = document.createElement('span');
          const [icon, ...labelParts] = tile.split(/\s+/);
          const label = labelParts.join(' ').trim();

          tileEl.className = 'product-usp-tiles__tile';
          iconEl.className = 'product-usp-tiles__icon';
          iconEl.setAttribute('aria-hidden', 'true');
          iconEl.textContent = icon;
          labelEl.className = 'product-usp-tiles__label';
          labelEl.textContent = label || tile;
          tileEl.append(iconEl, labelEl);

          return tileEl;
        })
      );
    }
  }

  customElements.define('product-usp-tiles', ProductUspTiles);
}
